<template>
  <div class="l-auth">
    <router-view/>
  </div>
</template>
